export const CAREGIVER_ROLE = {
	EXTERNAL: 'EXTERNAL',
	SHIFTMED: 'SHIFTMED'
};

export default CAREGIVER_ROLE;
